module.exports = __webpack_public_path__ + "images/services/confluence-mark-gradient-blue.e3c617b911cb6274c0f2.svg";